import { Box, Button, FormControl, Grid, IconButton, InputAdornment, Modal, OutlinedInput, Stack, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React from 'react';
import { useNavigate } from 'react-router';
import SearchIcon from '@mui/icons-material/Search';
import { IconPlus } from '@tabler/icons';
import { useState } from 'react';
import CustomNoRowsOverlay from 'ui-component/customNoRowsOverlay';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddEditLoansForm from './AddEditLoansForm';
import { useEffect } from 'react';
import { del, get } from '../../axios/apiService';
import toast from 'react-hot-toast';
import { Modules } from 'store/constant';
import LoadingBackdrop from 'ui-component/full-screen-loadder/LoadingBackdrop';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4
};

function Loans({ customerId }) {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [rowCount, setRowCount] = useState(0);
  const [isShowForm, setIsShowForm] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10
  });
  const [open, setOpen] = useState(false);
  const [sortModel, setSortModel] = useState([]);
  const [loans, setLoans] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [isDeleteLoanId, setIsDeleteLoanId] = useState('');
  const [isEditLoanId, setIsEditLoanId] = useState('');
  const [permissionMatrix, setPermissionMatrix] = useState({});

  useEffect(() => {
    if (!isShowForm) {
      setIsEditLoanId('');
    }
  }, [isShowForm]);

  useEffect(() => {
    fetchLoans();
  }, [paginationModel, sortModel, search, isShowForm, customerId]);

  useEffect(() => {
    const UserPermissions = JSON.parse(localStorage.getItem(`UserPermissions`));
    const permission = UserPermissions?.find((x) => x.moduleId === Modules.WillManagement_Loans);
    if (permission) {
      setPermissionMatrix(permission);
    } else {
      setPermissionMatrix(null);
    }
  }, []);

  const fetchLoans = async () => {
    setLoading(true);
    try {
      const sortField = sortLaonsFiled(sortModel.length ? sortModel[0].field : '');
      const sortOrder = sortModel.length ? (sortModel[0].sort === 'asc' ? 'Ascending' : 'Descending') : '';
      const sortQuery = sortField != '' ? `&sortField=${sortField}&sortDirection=${sortOrder}` : '';
      let response = await get(
        `Loans?page=${paginationModel.page}&pageSize=${paginationModel.pageSize}&searchTerm=${search}${sortQuery}&customerId=${customerId}`,
        null
      );
      if (response != null) {
        setLoans(response.values);
        setRowCount(response.totalCount);
      }
    } catch (err) {
      console.error(err?.message);
    } finally {
      setLoading(false);
    }
  };

  const ActionButtons = (row) => {
    return permissionMatrix && permissionMatrix.writeRights === true ? (
      <Stack direction={'row'} spacing={2}>
        <IconButton
          color="primary"
          size="large"
          onClick={() => {
            console.log('rowData', row);
            setIsShowForm(true);
            setIsEditLoanId(row.id);
            // handleClickOpen(row.id);
            // navigate(`/will-management/edit-insurance/${row.id}`);
          }}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          color="error"
          size="large"
          onClick={() => {
            // if (confirm(`Are you sure, you want to delete "${row.userName}" User?`)) {
            //   DeleteUser(row.id);
            // }
            setOpen(true);
            setIsDeleteLoanId(row.id);
          }}
        >
          <DeleteIcon />
        </IconButton>
      </Stack>
    ) : (
      <></>
    );
  };

  const columns = [
    { field: 'loanTypeName', headerName: 'Loan Type', flex: 1 },
    { field: 'bank', headerName: 'Bank', flex: 1 },
    { field: 'loanNumber', headerName: 'Loan Number', flex: 1 },
    { field: 'amount', headerName: 'Amount', flex: 1 },
    {
      field: 'action',
      headerName: 'Actions',
      renderCell: (params) => <ActionButtons {...params.row} />,
      align: 'right',
      width: 120,
      sortable: false,
      filterable: false
    }
  ];

  const handleClose = () => {
    setOpen(false);
  };
  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  const handleSortModelChange = (model) => {
    setSortModel(model);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  const DeleteLoan = async () => {
    if (isDeleteLoanId == null) {
      setOpen(false);
    }
    setLoading(true);
    try {
      let response = await del(`Loans/${isDeleteLoanId}`, null);
      if (!response) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      toast.success('Loan deleted successfully');
      handleClose();
      setPaginationModel({
        page: 0,
        pageSize: 10
      });
    } catch (error) {
      toast.error('Not deleting loan');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Grid container spacing={3}>
        {/* Table */}
        {isShowForm ? (
          <AddEditLoansForm setIsShowForm={setIsShowForm} id={isEditLoanId} customerId={customerId} />
        ) : (
          <>
            <Grid item xs={12}>
              <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={0}>
                <form noValidate autoComplete="off" style={{ marginRight: 10 }}>
                  <FormControl sx={{ width: '25ch' }} size="small">
                    <OutlinedInput
                      placeholder="Search"
                      value={search}
                      onChange={handleSearchChange}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: 'grey'
                          },
                          '&:hover fieldset': {
                            borderColor: 'black'
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: 'blue'
                          }
                        }
                      }}
                      endAdornment={
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </form>
                {permissionMatrix && permissionMatrix.writeRights === true ? (
                  <Button variant="contained" color="primary" onClick={() => {
                    if (!customerId) {
                      toast.error('Please select a customer to add a loan.');
                      return; 
                    }
                    setIsShowForm(true);
                  }} 
                  startIcon={<IconPlus />}>
                    Add
                  </Button>
                ) : (
                  <></>
                )}
              </Stack>
            </Grid>
            <Grid item xs={12}>
              <DataGrid
                getRowId={(row) => row.id}
                rows={loans}
                rowCount={rowCount}
                columns={columns}
                paginationMode="server"
                sortingMode="server"
                pageSizeOptions={[10]}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                components={{
                  NoRowsOverlay: CustomNoRowsOverlay
                }}
                sortModel={sortModel}
                onSortModelChange={handleSortModelChange}
              />
            </Grid>
          </>
        )}
      </Grid>

      {/* Delete modal */}
      <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box sx={style}>
          <Typography sx={{ fontSize: '20px' }} id="modal-modal-title" variant="h6" component="h2">
            Delete Confirmation
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Are you sure you want to delete this record?
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'end' }}>
            <Button
              onClick={handleClose}
              variant="contained"
              color="error"
              sx={{ marginTop: '20px', marginRight: '20px', padding: '5px 30px' }}
            >
              Cancel
            </Button>
            <Button variant="contained" sx={{ marginTop: '20px', padding: '5px 30px' }} onClick={DeleteLoan}>
              Confirm
            </Button>
          </Box>
        </Box>
      </Modal>
      <LoadingBackdrop open={isLoading} />
    </>
  );
}

export default Loans;
const sortLaonsFiled = (filed) => {
  if (filed == 'loanType') {
    return 'LoanType';
  } else if (filed == 'bank') {
    return 'Bank';
  } else if (filed == 'amount') {
    return 'Amount';
  } else if (filed == 'premium') {
    return 'Premium';
  } else if (filed == 'termInMonths') {
    return 'TermInMonths';
  }
  return '';
};
